@use "variables" as *;

.grid {
  overflow: auto;
  padding: $spacing-s;
}
